import React from "react";
import styled, {css} from "styled-components";
import typography, { rhythm } from "../utils/typography"
import presets from "../utils/presets";

const Ul = styled.ul`
  margin-left: 0;
  padding-left: ${rhythm(1)};
  list-style: none;
  color: ${props => props.brand ? presets.brand : presets.dark};
  font-family: ${presets.mono};
  display: inline-block;

  li{
    ::first-letter{
      text-transform: uppercase;
    }
    ::before{
      content:">";
      margin-left: ${rhythm(-1)};
      float:left;
      display:inline;
    }
  }

`

export default Ul



// WEBPACK FOOTER //
// ./src/com/Ul.js